import { Bindable } from "bindable-data";
import { NotifyProperty } from "bindable-data";
import { nameof } from "bindable-data";
import { ISettingsModel } from "./ISettingsModel";
import { sound } from "@pixi/sound";
import { IAnalyticProviderWrapper } from "../../analytics/IAnalyticProviderWrapper";
import { inject, singleton } from "@launchtray/tsyringe-async";
import { VirtualScreenEvent } from "../../analytics/events/VirtualScreenEvent";

@singleton()
export class SettingsModel extends Bindable implements ISettingsModel {
    private readonly analyticsProvider: IAnalyticProviderWrapper;
    public readonly soundEnabled: NotifyProperty<boolean>;

    public constructor(@inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper) {
        super();
        this.analyticsProvider = analyticsProvider;
        const value = localStorage.getItem("soundEnabled") !== "false";
        this.soundEnabled = new NotifyProperty<boolean>(this, nameof(this, "soundEnabled"), value);
        this.soundEnabled.value ? sound.unmuteAll() : sound.muteAll();
    }

    public switchSoundEnabled(): void {
        this.soundEnabled.setValue(!this.soundEnabled.value);
        if (this.soundEnabled.value) {
            sound.unmuteAll();
            this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Enable sound", this.analyticsProvider.currentEventIndex));
        } else {
            sound.muteAll();
            this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Disable Sound", this.analyticsProvider.currentEventIndex));
        };
        localStorage.setItem("soundEnabled", String(this.soundEnabled.value));
    }
}
